<div class="toast-wrapper">

  @if (title || message) {
    <div class="toast-container-show">
      <div class="toast-title">
        <span>{{title}}</span>
      </div>
      <div class="toast-message">
        <span>{{message}}</span>
      </div>
    </div>
  }
  @if (!title && !message && (lastTitle || lastMessage)) {
    <div class="toast-container-hide">
      <div class="toast-title">
        <span>{{lastTitle}}</span>
      </div>
      <div class="toast-message">
        <span>{{lastMessage}}</span>
      </div>
    </div>
  }

</div>